import TextInput from "../Formik/TextInput";
import RatingButtons from "./RatingButtons";
import TextArea from "../Formik/TextArea";
import React from "react";

const SubmitReviewStep1 = ({formik, vendorData}) => {

    return <div className="sl-display-flex sl-flex-col sl-gap-8">
        <div className="sl-display-flex sl-flex-row sl-width-100 sl-gap-8">
            <TextInput formik={formik} label={'Full Name'} name={'name'} disabled={true}/>
        </div>


        <div className="sl-display-flex sl-flex-row sl-width-100 sl-gap-8">
            <TextInput formik={formik} label={'Email'} name={'email_address'} disabled={true}/>
            <TextInput formik={formik} label={`Company name <span
                                    class="sl-text-gray-500">(optional)</span></span>`} name={'company_name'}/>

        </div>


        <div className="sl-display-flex sl-flex-col sl-width-100 sl-gap-5 sl-text-left">
            <span className="sl-font sl-font-medium sl-text-lg sl-text-gray-900 ">1.How would you rate your overall satisfaction with {vendorData.company.name} on a scale of 0 to 10?</span>
            <RatingButtons label={'Overall Rating'} formik={formik} name={'overall_rating'}/>
        </div>

        <TextArea
            label={"2.Please provide a review of this vendor?"}
            formik={formik} name={'comment'}/>
    </div>
}

export default SubmitReviewStep1;